// src/data/assignments.js

export const assignments = [
  {
    assignmentNumber: 2,
    title: "CodeCombat & Basic JavaScript",
    description: "Shows your mastery of core JS syntax",
    url: "images/codecombat-profile.jpg",
    modalImage: "images/codecombat-profile.jpg",
    image: "images/codecombat.jpg",
  },
  {
    assignmentNumber: 5,
    title: "Quiz App",
    description: "Interactive UI + event handling with jQuery",
    url: "https://srjcstudentsites.org/2025-spring/cs50c/05/HoganRobertR_02_17_17_32/webroot/",
    image: "images/quiz-app.jpg",
  },
  {
    assignmentNumber: 8,
    title: "Class Map",
    description: "AJAX + external API integration",
    url: "https://srjcstudentsites.org/2025-spring/cs50c/08/HoganRobertR_03_10_14_02/webroot/",
    image: "images/class-map.jpg",
  },
  {
    assignmentNumber: 9,
    title: "NFL Locations Interactive Map - Data Visualization",
    description: "D3.js",
    url: "https://srjcstudentsites.org/2025-spring/cs50c/09/HoganRobertR_03_24_07_07/webroot/",
    image: "images/data-viz.jpg",
  },
  {
    assignmentNumber: 13,
    title: "Basic Game",
    description: "Game loop + canvas interactivity",
    url: "https://srjcstudentsites.org/2025-spring/cs50c/13/HoganRobertR_04_21_12_44/phaser3-tutorial-src/part10.html",
    image: "images/basic-game.jpg",
  },
  {
    assignmentNumber: 14,
    title: "Your Game",
    description: "Fun updates to Basic Game",
    url: "https://srjcstudentsites.org/2025-spring/cs50c/14/HoganRobertR_04_28_22_05/phaser3-tutorial-src/part10.html",
    image: "images/your-game.jpg",
  },
];
